import React from "react";
import Container from "../Common/Container";
import { PageTitleProps } from "./interfaces/PageTitle";
import Button from "../primitives/Button";
import Text from "../Common/Text";

const DEFAULTDATA: PageTitleProps = {
  title: { value: "Título de página" },
  description: { value: "Descripción de la página" },
  image: {
    desktop:
      "https://assets.dogtorsoftware.com/1/website/f4b33021-6d57-4529-8be0-f10b13524069.jpg",
  },
  button: { name: "Más información", url: "#" },
};

const PageTitle = ({
  data = DEFAULTDATA,
  onChange,
}: {
  data: PageTitleProps;
  onChange: (value: any, id?: string) => void;
}) => {
  return (
    <div
      className="relative h-96 flex items-end pb-20"
      style={{
        background:
          "radial-gradient(210.46% 89.74% at 50% 0%, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.93) 100%), linear-gradient(rgba(255, 255, 255, 0) 22.5%, rgba(255, 255, 255, 0.106) 36.33%, rgb(255, 255, 255) 96.58%)",
      }}
    >
      <Container className="w-full">
        <div
          className="bg-cover bg-center w-full h-96 absolute left-0 top-0 -z-10"
          style={{
            backgroundImage: `url(${data?.image?.desktop})`,
          }}
        />
        <div>
          <div className={`page-container `}>
            <Text
              editor={!!onChange}
              id="PageTitle"
              onChange={(val) => onChange?.(val, "title")}
            >
              {data?.title}
            </Text>

            <div className="line-divider" />
          </div>
        </div>

        <div className={`background-gradient-image `} />

        <div className={`image-container`}></div>

        <div className={`button-container`}>
          <Button className="inline-block mt-5" {...data?.button} />
        </div>
      </Container>
    </div>
  );
};

export default PageTitle;
